import _ from 'lodash';

export default {
  computed: {
    tags() {
      return _.map(this.getCounts('tags'), (v, k) => ({ value: k, count: v }));
    },
    actions() {
      return _.map(this.getCounts('actions'), (v, k) => ({ value: k, count: v }));
    },
    categories() {
      return _.map(this.getCounts('categories'), (v, k) => ({ value: k, count: v }));
    },
  },
  data() {
    return {
      endpoint: 'primary/listAnalytics',
      analytics: null,
      filteredAnalytics: [],
      filter: [],
      digita: true,
    };
  },
  async mounted() {
    this.refresh();
  },
  watch: {
    filter() {
      this.filterAnalytics();
    },
    digita() {
      this.filterAnalytics();
    },
  },
  methods: {
    getCounts(key) {
      let items = [];
      if (this.analytics) {
        this.analytics.items.forEach((a) => {
          items = items.concat(a[key]);
        });
      }
      return _.countBy(items);
    },
    filterAnalytics() {
      if (this.analytics) {
        let analytics = this.analytics.items;
        if (!this.digita) {
          analytics = _.filter(analytics, { digita: this.digita });
        }
        this.filter.forEach((f) => {
          const filterItem = f.split(':');
          if (filterItem[0] === 'category') {
            analytics = _.filter(analytics, a => a.categories.includes(filterItem[1]));
          } else if (filterItem[0] === 'action') {
            analytics = _.filter(analytics, a => a.actions.includes(filterItem[1]));
          } else if (filterItem[0] === 'tag') {
            analytics = _.filter(analytics, a => a.tags.includes(filterItem[1]));
          }
        });
        this.filteredAnalytics = analytics;
      }
    },
    async refresh() {
      this.analytics = await this.$store.dispatch(this.endpoint);
      this.filteredAnalytics = this.analytics.items;
    },
  },
};
